import React, { Dispatch, SetStateAction } from "react";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import Flex from "../../../../../DefaultStyles/Flex";
import CheckBox from "../../../../../Button/CheckBox";
import ToolTip from "../../../../../Modal/ToolTip";

interface Props {
  isEditMode: boolean;
  party?: {
    state: {
      all: boolean;
      before: boolean;
      start: boolean;
      end: boolean;
    };
    role: {
      all: boolean;
      owner: boolean;
      member: boolean;
    };
  };
  setParty?: Dispatch<
    SetStateAction<{
      state: {
        all: boolean;
        before: boolean;
        start: boolean;
        end: boolean;
      };
      role: {
        all: boolean;
        owner: boolean;
        member: boolean;
      };
    }>
  >;
}

export default function FaqPartyStateInput({
  isEditMode,
  party,
  setParty,
}: Props) {
  const state = {
    all: false,
    before: false,
    start: false,
    end: false,
  };

  return (
    <FaqDetailRow>
      <FaqDetailLabel>
        파티 상태 선택
        <ToolTip
          msg="나의 파티, 도움말에 표시될 때 해당 파티의 상태"
          iconSize={18}
          direction="bottom"
        />
      </FaqDetailLabel>

      <Flex gapSize={58}>
        <CheckBox
          label="예정"
          checked={party?.state?.before}
          disabled={!isEditMode}
          onChange={(e: { target: { checked: any } }) => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                state: {
                  ...prev.state,
                  before: e.target.checked,
                },
              }));
          }}
        />

        <CheckBox
          label="시작"
          checked={party?.state?.start}
          disabled={!isEditMode}
          onChange={(e: { target: { checked: any } }) => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                state: {
                  ...prev.state,
                  start: e.target.checked,
                },
              }));
          }}
        />

        <CheckBox
          label="종료"
          checked={party?.state?.end}
          disabled={!isEditMode}
          onChange={(e: { target: { checked: any } }) => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                state: {
                  ...prev.state,
                  end: e.target.checked,
                },
              }));
          }}
        />
      </Flex>
    </FaqDetailRow>
  );
}
